import React from 'react';
import PriceMatrixCell from 'shared/product_tabs/tab_assembly/components/price/PriceMatrixCell';
import classnames from 'classnames';

const leadTimeText = d => `${d} ${d === 1 ? 'Day' : 'Days'}`;

const PriceMatrixHead = (props) => {
  const text = props.leadTimeText || leadTimeText

  return (
    <thead>
      {props.leadTimes.length == 6
        && <tr className='text-uppercase'>
          <th rowSpan='2'>QTY</th>
          <th className='express-th' colSpan='3'>QUICKTURN PCB ASSEMBLY SERVICE</th>
          <th className='standard-th' colSpan='3'>STANDARD PCB ASSEMBLY SERVICE</th>
        </tr>
      }
      <tr>
        {props.leadTimes.length != 6 && <th className="qty">Qty</th>}
        {props.leadTimes.map(qty => <th key={qty} className={`leadtime assembly-leadtime-${qty}`}>{text(qty)}</th>)}
      </tr>
    </thead>
  );
};

PriceMatrixHead.defaultProps = {
  leadTimes: [],
};

const PriceMatrixBody = props => (
  <tbody>
    {props.quantities.map((qty, row) => (
      <PriceMatrixRow
        key={row}
        quantity={qty}
        row={row}
        {...props} />
    ))}
  </tbody>
);

PriceMatrixBody.defaultProps = {
  quantities: [],
};

const PriceMatrixRow = (props) => {
  const MatrixCell = props.matrixCell ? props.matrixCell : PriceMatrixCell;
  return (
    <tr>
      <td className="qty">{props.quantity}</td>
      {props.leadTimes.map((leadTime, col) => (
        <MatrixCell
          cellClass={`assembly-leadtime-${leadTime}`}
          key={col}
          leadTime={leadTime}
          col={col}
          {...props} />
      ))}
    </tr>
  );
};

PriceMatrixRow.defaultProps = {
  leadTimes: [],
};


const PriceMatrix = (props) => {
  const lineItem = props.quote.line_items[0];
  if (lineItem === undefined) return null;

  const leadTimes = lineItem.lead_times;
  const quantities = lineItem.quantities;
  const cssClass = classnames('table table-bordered table-price-matrix table-assembly', {
    'table-striped': props.tableStripe,
    'table-sm': props.tableSm,
  })
  return (
    <div className="table-responsive">
      <table className={cssClass}>
        <PriceMatrixHead leadTimes={leadTimes} leadTimeTexleadTimeTextt={props.leadTimeText} />
        <PriceMatrixBody
          quantities={quantities}
          leadTimes={leadTimes}
          lineItem={lineItem}
          supplier={lineItem.product_key}
          parametersChanged={props.parametersChanged}
          {...props} />
      </table>
    </div>
  );
};

PriceMatrix.defaultProps = {
  tableStripe: false,
  tableSm: false,
}

export default PriceMatrix;
